import React from 'react';
import { ModalType } from '../../types/ModalType';
import useModal from '../../hooks/useModal';
import { StyledSecondaryColumn } from './StyledComponents';

type Props = {
  children: React.ReactNode;
  shouldHideOnMobile: boolean;
};

export default ({ children, shouldHideOnMobile }: Props) => {
  const { setActiveModal } = useModal();
  const handleDragEnter = () => {
    setActiveModal(ModalType.AttachmentsUploader);
  };

  return (
    <StyledSecondaryColumn $shouldHideOnMobile={shouldHideOnMobile} onDragEnter={handleDragEnter}>
      {children}
    </StyledSecondaryColumn>
  );
};
